import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent {
configForm!: FormGroup;
   configId :any;
   submitted = false;
   companyId: any;
   user: any;
   verification:any = false;
   companyWiseConfiguration: any;
 
   constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router,
    private sharedDataService:SharedDataService,
     private credentialService: CredentialService,
   ){
 
   }
 
   ngOnInit(){
    this.getUser();
     this.configForm = this.fb.group({
       reference: ['', Validators.required],
       generalUrl: ['', Validators.required],
       vehicleUrl: [''],
       driverUrl: [''],
       tripUrl: [''],
       company:[this.user.companyId],
       user:[this.user.id],
       isActive: [false],
     })
   }

    getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data:any) => {
      if (data) {
        this.user = data;
        this.companyId = this.user.company.id
        this.getConfigurationbyId();
      }
    })
  }

getConfigurationbyId() {
  this.credentialService.getConfigByCompanyWise(this.companyId)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data) {
        this.configId = data._id
        this.companyWiseConfiguration = data
        console.log('this.companyWiseConfiguration', this.companyWiseConfiguration);
        this.configForm.patchValue({
          ...data
        });
         if(data.validationFlags){
          this.verification = data.validationFlags;
        }
      }
    });
  }

  onSave() {
    this.submitted = true;
    if (this.configForm.invalid) return;

    const payload = this.configForm.value;

    this.credentialService.save(this.configId, payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.router.navigateByUrl('/dashboard');
          }
        },
        error: (err: any) => {
          sweetAlert("Error", err, "error", "OK");
        }
      });
  }

   get form(){
     return this.configForm.controls;
   }
}
